import _typeof from "@babel/runtime/helpers/esm/typeof";

/**
 * @constant
 * @description 是否是浏览器环境：true 表示客户端环境; false 表示服务端环境
 * @type {bool}
 * @memberof module:environment
 */
var isClient = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window && typeof document !== 'undefined';
/**
 * @constant
 * @description 是否是NodeJs服务器环境： true 表示客户端环境; false 表示服务端环境
 * @type {bool}
 * @memberof module:environment
 */

var isServer = !isClient;
/**
 * @description 检测当前环境是否支持WebP
 * @return {bool} Is this environment support WebP
 * @memberof module:environment
 */

function isSupportedWebP() {
  if (isServer) {
    return false;
  } // 同步的方式判断浏览器是否支持webp


  return !![].map && document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0;
}
/**
 * @constant
 * @description 检测当前环境是否支持WebRTC
 * @return {bool} Is this environment support WebRTC
 * @memberof module:environment
 */


var supportWebRTC = function supportWebRTC() {
  if (isServer) {
    return false;
  }

  var ua = navigator.userAgent.toLowerCase();
  var chromeVersion = ua.match(/chrome\/([\d]{2})/);

  if (chromeVersion) {
    chromeVersion = parseInt(chromeVersion[1], 10);
  }

  var firefoxVersion = ua.match(/firefox\/([\d]{2})/i);

  if (firefoxVersion && firefoxVersion[1]) {
    firefoxVersion = parseInt(firefoxVersion[1], 10);
  }

  var reg = /edge|lbbrowser|msie|firefox/i;

  if (!RTCPeerConnection || reg.test(ua) || chromeVersion && chromeVersion < 52 // (firefoxVersion && firefoxVersion < 61)
  ) {
      return false;
    }

  return true;
};
/**
 * @description 是否为特定的 IE 浏览器版本
 * @param {number} ver IE 版本号 6 7 8 9
 * @return {bool} true 表示是特定IE浏览器版本
 * @memberof module:environment
 */


function isIE(ver) {
  var b = document.createElement('b');
  b.innerHTML = "<!--[if IE ".concat(ver, "]><i></i><![endif]-->");
  return b.getElementsByTagName('i').length === 1;
}

export { isClient, isServer, isSupportedWebP, isIE, supportWebRTC };